<template>
	<div class="pipeline-filter-separator" :width="width" />
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "PipelineFilterSeparator",
	props: {
		width: {
			type: Number,
			default: 4,
			validator(value) {
				return [2, 4, 6, 8].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
@use "sass:math";
$widths: 2, 4, 6, 8;
.pipeline-filter-separator {
	height: 50px;

	background-color: var(--dashboard-input);

	@each $width in $widths {
		&[width="#{$width}"] {
			width: $width + px;
			border-radius: math.div($width, 2) + px;
		}
	}
}
</style>
